import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import { type MaybeRef, computed, unref, watchEffect } from 'vue';
import useViewTitle from './useViewTitle';

export default (viewName: MaybeRef<string>) => {
  const projectStore = useProjectStore();
  const projectName = computed(() =>
    projectStore.project.name == null ? '' : projectStore.project.name,
  );
  const getTitle = (viewName: MaybeRef<string>) =>
    `${unref(viewName)} | Project ${projectName.value}`.trim();

  const fullViewName = computed(() => getTitle(viewName));

  const { patch } = useViewTitle(fullViewName);

  watchEffect(() => {
    patch({
      title: fullViewName.value,
    });
  });
};
